<template>
  <v-form ref="form1">
    <v-layout row class="pl-1" wrap>
      <v-flex sm12 md5>
        <id-text-field
          v-model="o_genotype.id"
          label="Genotype id"
          required
          hint="Genotype identifier"
        ></id-text-field>
      </v-flex>
      <v-flex sm12 md5>
        <sequencing-data-text-field
          v-model="o_genotype.data"
          label="Data"
          required
          hint="SRA or fastq"
        ></sequencing-data-text-field>
      </v-flex>
      <v-flex sm12 md2>
        <v-btn fab dark small color="indigo" @click="addGenotype">
          <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-alert v-model="alert" dismissible type="error">Invalid form ...</v-alert>
  </v-form>
</template>

<script>
import SequencingDataTextField from './SequencingDataTextField.vue';
import IdTextField from './IdTextField.vue';

export default {
  components: { IdTextField, SequencingDataTextField },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      o_genotype: {},
      a_genotypes: this.value,
      alert: false,
    };
  },
  watch: {
    value(v) {
      this.a_genotypes = v;
    },
  },
  methods: {
    addGenotype() {
      if (this.$refs.form1.validate()) {
        this.a_genotypes.push(this.o_genotype);
        this.o_genotype = {};
        this.alert = false;
        this.$emit('input', this.a_genotypes);
        this.$refs.form1.reset();
      } else {
        this.alert = true;
      }
    },
  },
};
</script>
